import React, { ReactNode } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { generateCloudinaryUrl } from 'shared/helpers/generateCloudinaryUrl'

interface HeadProps {
  title: string
  description: string
  keywords?: string
  image?: string
  children?: ReactNode
}

/**
 * <head> container for metadata, it has the most common props we need to use for good SEO.
 */
const HeadContainer = ({
  title,
  description,
  keywords,
  image,
  children
}: HeadProps) => {
  const { asPath } = useRouter()

  const srcImage = image && generateCloudinaryUrl(image, 'thumb')
  // This is a sane default, we need a domain to use for the og tag but
  // vercel does not provide it. So use default domain, in this case widget.eola.co
  // this is to ensure marketplace fees are not used. People should not be sharing
  // links for demo / development so no need to be clever.
  const currentDomain = 'https://widget.eola.co'

  return (
    <Head>
      <title>{`${title} | eola`}</title>
      <meta name="description" content={description}></meta>
      {keywords && <meta name="keywords" content={keywords}></meta>}
      <meta property="og:title" content={title} />
      <meta property="og:type" content="WebSite" />
      <meta property="og:url" content={`${currentDomain}${asPath}`} />
      {image && (
        <>
          <meta property="og:image" content={srcImage} />
        </>
      )}
      {children}
    </Head>
  )
}

export default HeadContainer
